export default __webpack_public_path__ + "static/media/headphones-solid.db6ff1fb.svg";